import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import {
	EVENT_EMITTERS,
	PRINTABLE_ACCESS_KEYS,
	PRISTINE_PERMISSIONS
} from '../../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../../analytics/services/analytics.service';
import { WidgetCore } from '../../../../widget-library/interfaces/widget.core.interface';
import { NAVIGATION_REQUEST_STATUSES } from '../../../../../reporting/analytics-core/interfaces/configuration.interface';
import { AnalyticsMixpanelService } from '../../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-nav-item',
	styleUrls: ['./nav-item.component.css'],
	templateUrl: './nav-item.component.html'
})
export class NavItemComponent implements OnInit, AfterViewInit, WidgetCore {
	@Input() sectiontitle: string;
	@Input() sectionpath: string;
	@Input() sectionclass: string;
	@Input() key: string;
	public disabledimage: string;
	public loadR6Printable: boolean = false;
	public isDisabled = true;
	public isActive = false;
	public productCampaignsActiveCount: any = 0;
	public isR702overviewPrintable: boolean;
	public isR103: boolean;
	public allow: boolean = true;
	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		EmitterService.get(EVENT_EMITTERS.NAVIGATE).subscribe(() => {
			this.isActive = false;
		});
		EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
		EmitterService.get(EVENT_EMITTERS.NAVIGATION_DONE).subscribe((response: any) => {
			setTimeout(() => {
				this.isActive =
					this.analyticsDataModel.getCurrentPath() &&
					this.analyticsDataModel.getCurrentPath().length &&
					this.analyticsDataModel.getCurrentPath() === this.sectionpath;
				this.loadR6Printable = this.sectionpath == this.analyticsDataModel.getCurrentPath();
			}, 100);
		});
	}

	ngOnInit(): void {
		this.loadR6Printable = this.sectionpath == this.analyticsDataModel.getCurrentPath();
		this.isActive =
			this.analyticsDataModel.getCurrentPath() &&
			this.analyticsDataModel.getCurrentPath().length &&
			this.analyticsDataModel.getCurrentPath() === this.sectionpath;
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() == 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() == 'entravision-r103';
	}

	ngAfterViewInit(): void {
		this.requestData();
	}

	requestData(): void {
		this.analyticsDataModel.navigateProcessRequestStatus[this.sectionpath] = NAVIGATION_REQUEST_STATUSES.IN_PROGRESS;
		if (this.analyticsDataModel.selectedCampaigns.length <= 0) {
			this.isDisabled = true;
		}
		if (this.key !== '') {
			this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
				if (response.success) {
					this.processResponseData(response);
				} else {
					if (this.analyticsDataModel.overViewReportDetails.includes(this.sectiontitle)) {
						this.analyticsDataModel.overViewReportDetails.splice(
							this.analyticsDataModel.overViewReportDetails.indexOf(this.sectiontitle),
							1
						);
					}
				}
			});
		} else {
			if (
				this.sectiontitle === 'Overview' &&
				this.analyticsDataModel.selectedCampaigns.length > 0 &&
				this.analyticsDataModel.selectedAdvertisers.length > 0
			) {
				this.isDisabled = false;
			}
			setTimeout(() => {
				this.isActive =
					this.analyticsDataModel.getCurrentPath() &&
					this.analyticsDataModel.getCurrentPath().length &&
					this.analyticsDataModel.getCurrentPath() === this.sectionpath;
			}, 100);
			this.analyticsDataModel.navigateProcessRequestStatus[this.sectionpath] = NAVIGATION_REQUEST_STATUSES.COMPLETED;
		}
	}

	processResponseData(responseData: any): void {
		const data = responseData.data.length ? responseData.data[0] : {};
		if (data.status && !!parseInt(data.status, 10)) {
			this.isDisabled = false;
			if (!this.analyticsDataModel.overViewReportDetails.includes(this.sectiontitle)) {
				this.analyticsDataModel.overViewReportDetails.push(this.sectiontitle);
			}
		} else {
			this.isDisabled = true;
			if (this.analyticsDataModel.overViewReportDetails.includes(this.sectiontitle)) {
				this.analyticsDataModel.overViewReportDetails.splice(
					this.analyticsDataModel.overViewReportDetails.indexOf(this.sectiontitle),
					1
				);
			}
		}
		EmitterService.get(EVENT_EMITTERS.NAVIGATION_STATUS).emit({
			isDisabled: this.isDisabled,
			path: this.sectionpath
		});
		this.analyticsDataModel.navigateProcessRequestStatus[this.sectionpath] = NAVIGATION_REQUEST_STATUSES.COMPLETED;
		this.navigateAwayIfPathDisabled();
	}

	navigateAwayIfPathDisabled(): void {
		if (this.isDisabled && this.isActive) {
			EmitterService.get(EVENT_EMITTERS.NAVIGATE).emit({ name: this.analyticsDataModel.config.routing.defaultRoute });
		}
	}

	navigate(): void {
		this.allow = false;
		setTimeout(() => {
			this.allow = true;
		}, 500);

		if (
			!this.isDisabled &&
			this.analyticsDataModel.selectedCampaigns.length > 0 &&
			this.analyticsDataModel.selectedAdvertisers.length > 0 &&
			this.sectionpath !== this.analyticsDataModel.getCurrentPath()
		) {
			EmitterService.get(EVENT_EMITTERS.NAVIGATE).emit({ name: this.sectionpath });
			this.analyticsMixpanelService.mixpanelData('Analytics / ' + this.sectiontitle + ' Sidebar Product Clicked');
		}
	}
}
